import hexRgb from 'hex-rgb'
import { createTheme, ThemeOptions } from '@mui/material/styles'

import tailwind from 'styles/themeTokens'

// Manually specify custom MUI date picker component types
// REVIEW: upgrade MUI to see if it's built in.
type componentType = {
  styleOverrides?: {
    root?: {
      fontWeight: number
    }
    label?: {
      fontSize: number
      fontWeight: number
    }
  }
}

interface IThemeOptionsExtended extends ThemeOptions {
  components?: ThemeOptions['components'] & {
    MuiPickersCalendarHeader?: componentType
    MuiPickersDay?: componentType
  }
}

const muiLighthouseThemeOptions: IThemeOptionsExtended = {
  typography: {
    fontFamily: tailwind.theme.fontFamily.base.join(',')
  },
  shape: { borderRadius: 2 },
  palette: {
    mode: 'light',
    divider: tailwind.theme.colors.gray[300],
    text: {
      primary: tailwind.theme.colors.black,
      secondary: tailwind.theme.colors.gray[700],
      // JANA black w/ alpha
      disabled: 'rgba(35,31,32,0.3)'
      // hint: tailwind.theme.colors.gray[500]
    },
    primary: {
      light: tailwind.theme.colors.blue.lighthouse[200],
      main: tailwind.theme.colors.blue.lighthouse[500],
      dark: tailwind.theme.colors.blue.lighthouse[700],
      contrastText: tailwind.theme.colors.white
    },
    secondary: {
      light: tailwind.theme.colors.blue.lighthouse[200],
      main: tailwind.theme.colors.blue.lighthouse[500],
      dark: tailwind.theme.colors.blue.lighthouse[700],
      contrastText: tailwind.theme.colors.white
    },
    error: {
      main: '#DD668A',
      light: '#EBA3B9',
      dark: '#B1526E'
    },
    warning: {
      main: '#FFD87D',
      light: '#FFE8B1',
      dark: '#FFAF47',
      // JANA black w/ alpha
      contrastText: 'rgba(35,31,32,0.87)'
    },
    info: {
      light: tailwind.theme.colors.gray[100],
      main: tailwind.theme.colors.gray[300],
      dark: tailwind.theme.colors.gray[500],
      contrastText: tailwind.theme.colors.blue.lighthouse[500]
    },
    success: {
      main: '#4FBD90',
      light: '#8DCDAE',
      dark: '#509A7A',
      contrastText: '#ffffff'
    }
  },
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: hexRgb(tailwind.theme.colors.blue.navy.DEFAULT, {
            format: 'css',
            alpha: 0.85
          })
        }
      }
    },
    /**
     * Following customizations began from customizing the date picker
     */
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14
        },
        input: {
          padding: '0.5rem 0 0.5rem 14px !important'
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        // styling to the Month and Year Label
        label: {
          fontSize: 14,
          fontWeight: 600
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          // calendar column header and day number font
          fontWeight: 500
          // lighten date picker default focus color
          // ':focus': {
          // REVIEW: may want to increase specificity
          // backgroundColor: tailwind.theme.colors.blue.lighthouse[500]
          // }
        }
      }
    }
  }
}

export const muiLighthouseTheme = createTheme(muiLighthouseThemeOptions)
